import * as React from "react"

import Paragraph from "../paragraph"
import * as styles from "./index.module.scss"

type Props = React.HTMLAttributes<HTMLDivElement> & {
  errorMessage?: string
}

const Field: React.FC<Props> = ({
  className,
  children,
  errorMessage,
  ...otherProps
}) => {
  return (
    <div className={`${styles.field} ${className ?? ""}`} {...otherProps}>
      {children}
      {errorMessage && (
        <Paragraph variant="3" className={styles.errorMessage}>
          {errorMessage}
        </Paragraph>
      )}
    </div>
  )
}

export default Field
